import { useQuery } from "@tanstack/react-query";
import { getMerchantsPublicIDTerminalContracts } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const MERCHANT_TERMINAL_CONTRACTS_QUERY_KEY = "MERCHANT_TERMINAL_CONTRACTS";

export const getMerchantTerminalContractsQueryKey = (
  merchantPublicID: string,
) => [MERCHANT_TERMINAL_CONTRACTS_QUERY_KEY, merchantPublicID];

export const useGetMerchantTerminalContractsQuery = (
  merchantPublicID: string,
) =>
  useQuery({
    queryKey: getMerchantTerminalContractsQueryKey(merchantPublicID),
    queryFn: processResponseWithApiProblemDetails(() =>
      getMerchantsPublicIDTerminalContracts(merchantPublicID),
    ),
  });
